import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions, selectors } from 'src/store';

const useAiChat = () => {
  const dispatch = useDispatch();

  const messages = useSelector(selectors.aiChat.getMessages);
  const isLoading = useSelector(selectors.aiChat.getIsLoading);
  const hasError = useSelector(selectors.aiChat.getHasError);
  const errorMessage = useSelector(selectors.aiChat.getErrorMessage);
  const isVisible = useSelector(selectors.aiChat.getIsVisible);
  const hasUnreadDailyMessage = useSelector(
    selectors.aiChat.getHasUnreadDailyMessage
  );
  const lastDailyCheckDate = useSelector(
    selectors.aiChat.getLastDailyCheckDate
  );

  const sendMessage = useCallback(
    (prompt, context) => {
      return dispatch(actions.aiChat.sendChatMessage(prompt, context));
    },
    [dispatch]
  );

  const fetchDailyCheck = useCallback(
    (locale) => {
      return dispatch(actions.aiChat.fetchDailyCheck(locale));
    },
    [dispatch]
  );

  const markDailyMessageAsRead = useCallback(() => {
    dispatch(actions.aiChat.markDailyMessageAsRead());
  }, [dispatch]);

  const resetChat = useCallback(() => {
    dispatch(actions.aiChat.resetChat());
  }, [dispatch]);

  const toggleVisibility = useCallback(() => {
    dispatch(actions.aiChat.toggleVisibility());
  }, [dispatch]);

  return {
    messages,
    isLoading,
    hasError,
    errorMessage,
    isVisible,
    hasUnreadDailyMessage,
    lastDailyCheckDate,
    sendMessage,
    fetchDailyCheck,
    markDailyMessageAsRead,
    resetChat,
    toggleVisibility,
  };
};

export default useAiChat;
